import React from 'react';
import { ParallaxProvider, config } from '@adc/parallax-component-library';
import { useTheme as useThemeName } from 'Hooks';
import { store } from 'Utilities/store';
const Providers = ({ children }) => {
    const { theme: themeName } = useThemeName();
    const defaultTheme = themeName.endsWith('Dark') ? 'dark' : 'light';
    const locale = store.getState().env.phoneLanguage;
    return (React.createElement(ParallaxProvider, { config: config, locale: locale, dir: "ltr", defaultTheme: defaultTheme }, children));
};
export { Providers };
